<div class="flex flex-col justify-center items-center w-24">
	<img src="assets/images/teranet-logo.svg" />
</div>
<div
	*ngIf="state === states.CHANGE_PASSWORD"
	class="flex flex-col justify-center items-center w-full"
>
	<p class="font-bold text-xl mb-2">Update your password</p>
	<app-teranet-change-password
		[accountName]="accountName"
		class="border-t mt-8 w-full"
	></app-teranet-change-password>
</div>
<div
	*ngIf="state === states.LOGIN"
	class="flex flex-col justify-center items-center py-4 w-full"
>
	<p class="font-bold text-xl mb-2">Validate your Teranet Credentials</p>
	<app-teranet-login
		class="mt-8 w-full"
		action="validate"
		[accountName]="accountName"
	></app-teranet-login>
</div>
